import '@mui/lab/themeAugmentation';
import { createTheme } from '@mui/material/styles';

export const ArSmartflowTheme = createTheme({
    typography: {
        fontFamily: '"League Spartan", sans-serif',
    },
    palette: {
        mode: 'dark',
        primary: {
            main: '#59B8CA',
        },
        success: {
            main: '#CCFF95',
        },
        error: {
            main: '#FF9595',
        },
        text: {
            primary: '#D9D9D9',
        },
        info: {
            main: '#2C375A',
        },
        warning: {
            main: '#FFD57A',
        },
    },
});
